<template>
	<div class="risks">
		<query-builder :key="refreshKey" :cubejs-api="cubejsApi" :query="query">
			<template v-slot="{ loading, resultSet }">
				<chart-adapter v-if="!loading && resultSet" type="line" :companyName='companyName' :yjz='yjz' :result-set="resultSet"
					height="369" />
			</template>
		</query-builder>
	</div>
</template>

<script>
	import cubejs from "@cubejs-client/core";
	import Multiselect from "vue-multiselect";
	import {
		QueryBuilder
	} from "@cubejs-client/vue";
	import ChartAdapter from './KaipRiskReport/ChartAdapter.vue'

	const API_URL = "http://test.nssb.taxunion.com.cn:8888/cubejs-api/v1";
	const CUBEJS_TOKEN =
		"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE1OTQ2NjY4OTR9.0fdi5cuDZ2t3OSrPOMoc3B1_pwhnWj4ZmM3FHEX7Aus";

	const cubejsApi = cubejs(CUBEJS_TOKEN, {
		apiUrl: API_URL
	});

	export default {
		props: {
			companyName: {
				type: String,
				default: "",
			}, //名
			yjz: {
				type: String,
				default: "",
			}, //预警值
			riskData: Array,
			measures: {
				type: Array,
				default: ["ReportRisk.companyCode1", "ReportRisk.companyCode2", "ReportRisk.companyCode3",
					"ReportRisk.companyCode4", "ReportRisk.companyCode5", "ReportRisk.companyCode6",
					"ReportRisk.companyCode7", "ReportRisk.companyCode8",
					"ReportRisk.companyCode9", "ReportRisk.companyCode10", "ReportRisk.companyCode11",
					"ReportRisk.companyCode12", "ReportRisk.companyCode13", "ReportRisk.companyCode14",
					"ReportRisk.companyCode15", "ReportRisk.companyCode16", "ReportRisk.companyCode17"
				]
			},
		},
		name: "RiskReport",
		components: {
			QueryBuilder,
			ChartAdapter
			// ChartRenderer,
		},
		data() {
			const query = {
				"measures": [

				],
				"timeDimensions": [],
				"order": {
					"ReportRisk.value": "desc"
				},
				"dimensions": [
					"ReportRisk.shenbq",
				],
				filters: [
					// {
					//   dimension: 'ReportRisk.companyCode',
					//   operator: 'equals',
					//   values: ['1100','1300','1200','1320','1330','1700','1500','1020','1000','4300','1120','1400','1130','1340','1300-1','1300-2','1300-3']
					// },
					{
						dimension: 'ReportRisk.riskIndex',
						operator: 'equals',
						values: []
					}
				]
			};

			return {
				cubejsApi,
				selected: undefined,
				query,
				refreshKey: 0,
				layout: [{
						x: 0,
						y: 0,
						w: 4,
						h: 3,
						i: 'totalUsers'
					},
					{
						x: 4,
						y: 0,
						w: 4,
						h: 3,
						i: 'totalOrders'
					},
					{
						x: 8,
						y: 0,
						w: 4,
						h: 3,
						i: 'shippedOrders'
					},
					{
						x: 0,
						y: 4,
						w: 6,
						h: 9,
						i: 'newUsers'
					},
					{
						x: 6,
						y: 4,
						w: 6,
						h: 9,
						i: 'userByYear'
					}
				],
			};
		},
		created() {
			this.query.filters[0].values = this.riskData;
			this.query.measures = this.measures;
		},
		watch: {
			riskData(newValue) {
				// 当 value 属性发生变化时触发
				// 在这里可以执行相应的操作
				// 执行其他操作或刷新页面
				console.log(newValue)
				this.refreshPage();
			},
		},
		methods: {
			customLabel(a) {
				return a.title;
			},
			set(setMeasures, value) {
				setMeasures(value.map((e) => e.name));
			},
			refreshPage() {
				this.query.filters[0].values = this.riskData;
				this.refreshKey++;
			}
		},
	};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
	h3 {
		margin: 40px 0 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.risks {
		min-width: 600px;
		max-width: 800px;
	}
</style>